(() => {
  if (window.ffAccountInitialized) return;
  const access = document.querySelector('[data-ff-account-access]');
  if (!access) return;
  window.ffAccountInitialized = true;
  const dialog = document.getElementById('FaimlyAccountDialog');
  const compact = document.getElementById('FaimlyMobileAccessDialog');
  const mobileTrigger = access.querySelector('[data-ff-mobile-otp-trigger]');
  const hub = document.querySelector('[data-ff-account-hub]');
  const entrySelector = '[data-ff-account-entry], .header__icon--account';
  const intentKey = 'faimly-account-return-v2';
  const seenKey = 'faimly-account-popup-v2';
  const startKey = 'faimly-account-browsing-start-v2';
  const purchaseKey = 'faimly-account-purchase-intent-v2';
  const hubUrl = new URL(access.dataset.hubUrl || '/pages/kp-account?view=ff-account', location.origin);
  const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
  if (previewTheme && /^\d+$/.test(previewTheme)) hubUrl.searchParams.set('preview_theme_id', previewTheme);
  let shopifySessionActive = access.dataset.signedIn === 'true';
  let signedIn = shopifySessionActive;
  let sessionCheckedAt = shopifySessionActive ? Date.now() : 0;
  let sessionRequest = null;
  let sessionGeneration = 0;
  let verifiedSession = shopifySessionActive ? { active: true } : null;
  let lastSessionFingerprint = null;
  let loginRequest = null;
  let loginGeneration = 0;
  let loginIntent = null;
  let detailsIntent = null;
  let detailsRequest = null;
  const detailsLabels = { orders: 'My Orders order history', addresses: 'Addresses shipping and billing', profile: 'Profile personal info' };
  let previousFocus = null;
  let navigating = false;
  let seen = false;
  let autoTimer = null;
  let purchaseIntent = Number(access.dataset.ffAccountCartCount) > 0;
  let oldScrollbar = '';
  let scrollingLocked = false;
  let autoAttempting = false;
  let providerLoginPending = false;
  const originalHubName = hub?.querySelector('[data-ff-account-name]')?.textContent;
  const originalHubTitle = hub?.querySelector('#FaimlyAccountTitle')?.textContent;
  const storageRead = key => { try { return sessionStorage.getItem(key); } catch (_) { return null; } };
  const storageWrite = (key, value) => { try { sessionStorage.setItem(key, value); } catch (_) {} };
  const storageRemove = key => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const localDestination = value => {
    try {
      const url = new URL(value || hubUrl.href, location.origin);
      if (url.origin !== location.origin || url.username || url.password || /^\/\//.test(value || '') || /[\u0000-\u001f\u007f]/.test(value || '')) return null;
      if (/^\/(?:account\/(?:login|logout)|customer_authentication\/)/.test(url.pathname)) return null;
      if (previewTheme && /^\d+$/.test(previewTheme) && !url.pathname.startsWith('/apps/')) url.searchParams.set('preview_theme_id', previewTheme);
      return url.pathname + url.search + url.hash;
    } catch (_) { return null; }
  };
  const clearIntent = () => { loginIntent = null; detailsIntent = null; storageRemove(intentKey); };
  try {
    const saved = JSON.parse(storageRead(intentKey));
    const destination = localDestination(saved?.returnTo);
    if (destination && Number.isFinite(saved?.at) && saved.at <= Date.now() && Date.now() - saved.at < 600000) {
      loginIntent = destination;
      detailsIntent = Object.hasOwn(detailsLabels, saved.details) ? saved.details : null;
    }
    else storageRemove(intentKey);
  } catch (_) { storageRemove(intentKey); }
  const setIntent = (returnTo, details = null) => {
    loginIntent = localDestination(returnTo) || hubUrl.pathname + hubUrl.search;
    detailsIntent = Object.hasOwn(detailsLabels, details) ? details : null;
    storageWrite(intentKey, JSON.stringify({ returnTo: loginIntent, details: detailsIntent, at: Date.now() }));
  };
  const markSeen = () => {
    seen = true;
    storageWrite(seenKey, 'seen');
    clearTimeout(autoTimer);
  };
  const hasSeen = () => seen || storageRead(seenKey) === 'seen';
  const markPurchase = () => {
    purchaseIntent = true;
    storageWrite(purchaseKey, 'yes');
    clearTimeout(autoTimer);
  };
  purchaseIntent ||= storageRead(purchaseKey) === 'yes';
  const otpSessionToken = () => {
    try {
      if (localStorage.getItem('otp_plus_logout_pending')) return null;
      return localStorage.getItem('otp_plus_nca_session_token') || sessionStorage.getItem('otp_plus_nca_session_token');
    } catch (_) { return null; }
  };
  const syncEntries = () => {
    document.querySelectorAll(entrySelector).forEach(link => {
      link.href = hubUrl.pathname + hubUrl.search;
      link.toggleAttribute('data-ff-account-open', !signedIn);
      if (signedIn) {
        link.removeAttribute('aria-haspopup');
        link.removeAttribute('aria-controls');
        link.removeAttribute('aria-expanded');
      } else {
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-controls', 'FaimlyMobileAccessDialog');
        link.setAttribute('aria-expanded', 'false');
      }
      if (access.dataset.accountLabel) link.setAttribute('aria-label', access.dataset.accountLabel);
    });
  };
  const syncHub = session => {
    if (!hub || shopifySessionActive) return;
    hub.querySelectorAll('[data-ff-account-guest]').forEach(node => { node.hidden = signedIn; });
    hub.querySelectorAll('[data-ff-account-otp]').forEach(node => { node.hidden = !signedIn; });
    const identity = hub.querySelector('[data-ff-account-name]');
    const title = hub.querySelector('#FaimlyAccountTitle');
    const name = signedIn && typeof session?.name === 'string' ? session.name.trim() : '';
    if (identity) identity.textContent = name || originalHubName || '';
    if (title) title.textContent = name && hub.dataset.hello ? hub.dataset.hello.replace('__name__', name) : originalHubTitle || '';
  };
  const applySession = (session, source) => {
    signedIn = session?.active === true && session.pending_signup !== true && session.needs_profile !== true;
    verifiedSession = signedIn ? session : null;
    sessionCheckedAt = Date.now();
    syncEntries();
    syncHub(session);
    if (signedIn) markSeen();
    const verifiedSource = signedIn ? source : 'none';
    const customerId = signedIn && (typeof session?.customer_id === 'string' || Number.isSafeInteger(session?.customer_id)) ? String(session.customer_id).trim().replace(/^gid:\/\/shopify\/Customer\//, '') : '';
    const identity = verifiedSource === 'otp' ? customerId ? ['customer', customerId] : ['contact', typeof session?.email === 'string' ? session.email.trim().toLowerCase() : '', typeof session?.phone === 'string' ? session.phone.trim() : ''] : [];
    const fingerprint = JSON.stringify([signedIn, verifiedSource, identity]);
    if (fingerprint !== lastSessionFingerprint) {
      lastSessionFingerprint = fingerprint;
      window.dispatchEvent(new CustomEvent('ff:account-session', { detail: { signedIn, source: verifiedSource } }));
    }
  };
  const refresh = () => {
    if (shopifySessionActive) {
      const session = { active: true };
      applySession(session, 'shopify');
      return Promise.resolve(session);
    }
    if (sessionRequest) return sessionRequest;
    const generation = sessionGeneration;
    const token = otpSessionToken();
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    const pending = fetch('/apps/social-icons/api/nca/session/status', {
      credentials: 'same-origin', cache: 'no-store', redirect: 'error',
      headers: token ? { 'X-OTP-NCA-Token': token } : {}, signal: controller.signal
    }).then(response => response.ok ? response.json() : null).then(session => {
      if (generation !== sessionGeneration) return null;
      if (session && typeof session.active === 'boolean') {
        applySession(session, 'otp');
        return session;
      }
      return null;
    }).catch(() => null).finally(() => {
      clearTimeout(timeout);
      if (sessionRequest === pending) sessionRequest = null;
    });
    sessionRequest = pending;
    return sessionRequest;
  };
  const invalidate = () => {
    sessionGeneration += 1;
    shopifySessionActive = false;
    sessionRequest = null;
    applySession({ active: false }, 'none');
    sessionCheckedAt = 0;
  };
  const syncScroll = () => {
    const open = !!dialog?.open || !!compact?.open;
    if (open && !scrollingLocked) {
      oldScrollbar = document.documentElement.style.getPropertyValue('--ff-account-scrollbar');
      document.documentElement.style.setProperty('--ff-account-scrollbar', `${Math.max(0, window.innerWidth - document.documentElement.clientWidth)}px`);
    }
    if (!open && scrollingLocked) {
      if (oldScrollbar) document.documentElement.style.setProperty('--ff-account-scrollbar', oldScrollbar);
      else document.documentElement.style.removeProperty('--ff-account-scrollbar');
    }
    scrollingLocked = open;
    document.documentElement.classList.toggle('ff-account-is-open', open);
  };
  const closeOwn = () => {
    if (dialog?.open) dialog.close();
    if (compact?.open) compact.close();
    syncScroll();
  };
  const restoreFocus = () => {
    if (previousFocus instanceof HTMLElement && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  };
  const compactStatus = (mode, show = true) => {
    if (!compact) return;
    const node = compact.querySelector('[data-ff-compact-status]');
    const retry = compact.querySelector('[data-ff-compact-retry]');
    if (node) node.textContent = compact.dataset[mode] || '';
    if (retry) { retry.hidden = mode !== 'unavailable'; retry.disabled = mode !== 'unavailable'; }
    compact.setAttribute('aria-busy', String(mode !== 'unavailable'));
    if (show && !compact.open && typeof compact.showModal === 'function') {
      if (dialog?.open) dialog.close();
      compact.showModal();
      syncScroll();
    }
  };
  const otpAvailable = () => window.__otpAccountInterceptReady === true && !!document.getElementById('otp-nca-account-modal');
  const otpModal = () => {
    const modal = document.querySelector('#otp-nca-account-modal [role="dialog"]');
    return modal && modal.getBoundingClientRect().width > 0 && getComputedStyle(modal).visibility !== 'hidden' ? modal : null;
  };
  const waitFor = async (predicate, generation) => {
    for (let attempt = 0; attempt < 24; attempt += 1) {
      if (generation !== loginGeneration) return false;
      if (predicate()) return true;
      await new Promise(resolve => setTimeout(resolve, 250));
    }
    return generation === loginGeneration && predicate();
  };
  const navigateIntent = (replace = false) => {
    if (!signedIn || !loginIntent || navigating) return;
    if (detailsIntent && !shopifySessionActive) {
      void openDetails(detailsIntent).then(opened => { if (opened) clearIntent(); });
      return;
    }
    const target = loginIntent;
    clearIntent();
    closeOwn();
    const current = location.pathname + location.search + location.hash;
    if (target === current || (hub && target === hubUrl.pathname + hubUrl.search)) {
      otpModal()?.querySelector('.otp-account-modal__close')?.click();
      restoreFocus();
      return;
    }
    navigating = true;
    if (replace) location.replace(target); else location.assign(target);
  };
  const openProvider = async generation => {
    compactStatus('loading');
    const ready = mobileTrigger && await waitFor(otpAvailable, generation);
    if (generation !== loginGeneration) return false;
    if (!ready) { compactStatus('unavailable'); return false; }
    closeOwn();
    mobileTrigger.click();
    const opened = await waitFor(() => !!otpModal(), generation);
    if (generation !== loginGeneration) return false;
    if (!opened && !signedIn) compactStatus('unavailable');
    return opened;
  };
  const openDetails = name => {
    if (detailsRequest) return detailsRequest;
    const generation = loginGeneration;
    detailsRequest = (async () => {
      if (!Object.hasOwn(detailsLabels, name) || !signedIn) return false;
      const selector = `.otp-account-dashboard .otp-account-dashboard__nav-item[aria-label="${detailsLabels[name]}"]`;
      let button = document.querySelector(selector);
      if (!button) {
        compactStatus('loading');
        const ready = mobileTrigger && await waitFor(otpAvailable, generation);
        if (!ready || generation !== loginGeneration) { if (generation === loginGeneration) compactStatus('unavailable'); return false; }
        closeOwn();
        if (!otpModal()) mobileTrigger.click();
        await waitFor(() => !!document.querySelector(selector), generation);
        if (generation !== loginGeneration) return false;
        button = document.querySelector(selector);
      }
      if (!button) { if (!otpModal()) compactStatus('unavailable'); return false; }
      closeOwn();
      button.click();
      return true;
    })().finally(() => { detailsRequest = null; });
    return detailsRequest;
  };
  const requestLogin = (returnTo, details = null) => {
    if (loginRequest) return loginRequest;
    setIntent(returnTo, details);
    previousFocus = document.activeElement;
    markSeen();
    const generation = ++loginGeneration;
    loginRequest = (async () => {
      if (shopifySessionActive || (signedIn && Date.now() - sessionCheckedAt < 30000)) {
        navigateIntent();
        return true;
      }
      compactStatus('checking');
      const session = Date.now() - sessionCheckedAt < 30000 && sessionCheckedAt ? verifiedSession || { active: false } : await refresh();
      if (generation !== loginGeneration) return false;
      if (!session) { compactStatus('unavailable'); return false; }
      if (signedIn) { navigateIntent(); return true; }
      return openProvider(generation);
    })().finally(() => { loginRequest = null; });
    return loginRequest;
  };
  const requestDetails = name => {
    if (!Object.hasOwn(detailsLabels, name) || shopifySessionActive) return Promise.resolve(false);
    return requestLogin(location.pathname + location.search + location.hash, name);
  };
  window.ffAccountSession = { isSignedIn: () => signedIn, refresh, invalidate, requestLogin: returnTo => requestLogin(returnTo), requestDetails };
  mobileTrigger?.addEventListener('click', event => event.preventDefault());
  const cancelLogin = () => {
    loginGeneration += 1;
    clearIntent();
    closeOwn();
    restoreFocus();
  };
  const setMode = mode => {
    if (!dialog) return;
    const selected = mode === 'register' ? 'register' : 'login';
    dialog.querySelectorAll('[data-ff-auth-tab]').forEach(tab => {
      const active = tab.dataset.ffAuthTab === selected;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    dialog.querySelectorAll('[data-ff-auth-panel]').forEach(panel => { panel.hidden = panel.dataset.ffAuthPanel !== selected; });
    const title = dialog.querySelector(`[data-ff-auth-panel="${selected}"] h2`);
    if (title) dialog.setAttribute('aria-labelledby', title.id);
  };
  const openChooser = () => {
    if (!dialog || signedIn || typeof dialog.showModal !== 'function') return;
    previousFocus = document.activeElement;
    setMode('login');
    dialog.showModal();
    syncScroll();
    markSeen();
    dialog.querySelector('[data-ff-auth-tab][aria-selected="true"]')?.focus({ preventScroll: true });
  };
  const purchaseTarget = target => target.closest('[name="checkout"], [name="add"], [data-add-to-cart], [data-buy-now], [data-pay-now], [data-pilot-add], [data-add], [data-wallet-checkout], [data-ff-wallet-apply], .shopify-payment-button, a[href^="/checkout"], a[href^="/cart"], [data-cart-sidebar]');
  window.addEventListener('click', event => {
    if (!(event.target instanceof Element) || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const target = event.target;
    if (purchaseTarget(target)) markPurchase();
    const email = target.closest('[data-ff-auth-email]');
    if (email && dialog?.contains(email)) {
      markSeen();
      event.stopImmediatePropagation();
      return;
    }
    const retry = target.closest('[data-ff-compact-retry]');
    if (retry) { event.preventDefault(); void requestLogin(loginIntent || undefined, detailsIntent); return; }
    if (target.closest('[data-ff-compact-close], [data-ff-account-close]')) {
      event.preventDefault(); cancelLogin(); return;
    }
    const details = target.closest('[data-ff-account-details]');
    if (details && !shopifySessionActive && Object.hasOwn(detailsLabels, details.dataset.ffAccountDetails)) {
      event.preventDefault(); event.stopImmediatePropagation();
      void requestDetails(details.dataset.ffAccountDetails);
      return;
    }
    const mobile = target.closest('[data-ff-auth-mobile]');
    const entry = target.closest(`${entrySelector}, [data-ff-account-open], [data-ff-secure-login]`);
    if (mobile || entry) {
      event.preventDefault();
      event.stopImmediatePropagation();
      void requestLogin(entry?.dataset.ffReturnTo || undefined);
      return;
    }
    const tab = target.closest('[data-ff-auth-tab], [data-ff-auth-mode]');
    if (tab && dialog?.contains(tab)) { setMode(tab.dataset.ffAuthTab || tab.dataset.ffAuthMode); return; }
    if (target.closest('[data-ff-account-logout]')) { markSeen(); clearIntent(); }
  }, true);
  document.addEventListener('submit', event => {
    if (event.target instanceof HTMLFormElement && /\/(?:cart|checkout)(?:\/|$)/.test(event.target.action)) markPurchase();
  }, true);
  for (const name of ['cart:updated', 'cart:add', 'cart:change', 'ff:purchase-intent']) document.addEventListener(name, markPurchase);
  window.addEventListener('ff:wishlist-prompt', markSeen);
  document.addEventListener('keydown', event => {
    const tab = event.target instanceof Element ? event.target.closest('[data-ff-auth-tab]') : null;
    if (!tab || !dialog?.contains(tab) || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    setMode(event.key === 'Home' ? 'login' : event.key === 'End' ? 'register' : tab.dataset.ffAuthTab === 'login' ? 'register' : 'login');
    dialog.querySelector('[data-ff-auth-tab][aria-selected="true"]')?.focus();
  });
  for (const ownedDialog of [dialog, compact]) {
    if (!ownedDialog) continue;
    ownedDialog.addEventListener('cancel', event => { event.preventDefault(); cancelLogin(); });
    ownedDialog.addEventListener('close', syncScroll);
    ownedDialog.addEventListener('click', event => {
      if (event.target !== ownedDialog) return;
      const rect = ownedDialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) cancelLogin();
    });
  }
  let completingLogin = false;
  const finishProviderLogin = () => {
    const modal = otpModal();
    if (!signedIn || !providerLoginPending || (modal && !modal.querySelector('.otp-account-dashboard'))) return;
    providerLoginPending = false;
    closeOwn();
    navigateIntent();
  };
  const verifyCompletedLogin = async () => {
    if (completingLogin) return;
    completingLogin = true;
    try {
      for (let attempt = 0; attempt < 4; attempt += 1) {
        const session = await refresh();
        if (session?.active === true && !session.pending_signup && !session.needs_profile) { finishProviderLogin(); return; }
        if (attempt < 3) await new Promise(resolve => setTimeout(resolve, 350));
      }
    } finally { completingLogin = false; }
  };
  window.addEventListener('otp-plus-nca-login', () => { providerLoginPending = true; markSeen(); void verifyCompletedLogin(); });
  window.addEventListener('otp:external-logout', () => {
    providerLoginPending = false;
    clearIntent();
    invalidate();
  });
  const observeOtp = root => {
    let hadModal = false;
    const sync = () => {
      const modal = root.querySelector('[role="dialog"]');
      if (!modal) {
        if (providerLoginPending) finishProviderLogin();
        else if (hadModal && !completingLogin && !signedIn) clearIntent();
        hadModal = false;
        return;
      }
      hadModal = true;
      markSeen();
      closeOwn();
      const phone = modal.querySelector('input[type="tel"]');
      if (phone) {
        if (!phone.hasAttribute('aria-label') && !phone.hasAttribute('aria-labelledby') && phone.placeholder) phone.setAttribute('aria-label', phone.placeholder);
        if (!phone.hasAttribute('inputmode')) phone.setAttribute('inputmode', 'tel');
      }
      if (modal.querySelector('.otp-account-dashboard') && loginIntent) { providerLoginPending = true; void verifyCompletedLogin(); }
    };
    new MutationObserver(sync).observe(root, { childList: true, subtree: true });
    sync();
  };
  const otpRoot = document.getElementById('otp-nca-account-modal');
  if (otpRoot) observeOtp(otpRoot);
  else {
    const observer = new MutationObserver(() => {
      const root = document.getElementById('otp-nca-account-modal');
      if (root) { observer.disconnect(); observeOtp(root); }
    });
    observer.observe(document.body, { childList: true });
  }
  document.querySelectorAll('[data-ff-preview-link]').forEach(link => {
    if (!previewTheme) return;
    const target = localDestination(link.href);
    if (target) link.href = target;
  });
  const purchasePage = /^\/(?:cart|checkout)(?:\/|$)/.test(location.pathname) || /^\/pages\/products-samples\/?$/.test(location.pathname) || /^\/products\/[^/]*rs-1-trial\/?$/.test(location.pathname);
  if (purchaseIntent || purchasePage) markPurchase();
  const overlayActive = () => document.hidden || (document.activeElement instanceof Element && document.activeElement.matches('input, textarea, select, [contenteditable="true"]')) || document.body.classList.contains('cart-sidebar-show') || document.body.classList.contains('search-modal-show') || !!Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).find(node => {
    const rect = node.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && getComputedStyle(node).visibility !== 'hidden';
  });
  let browsingStarted = Number(storageRead(startKey));
  if (!browsingStarted || browsingStarted > Date.now()) { browsingStarted = Date.now(); storageWrite(startKey, String(browsingStarted)); }
  const delay = Math.min(900000, Math.max(600000, Number(access.dataset.delay) || 900000));
  const autoEligible = () => !signedIn && !hasSeen() && !purchaseIntent && !purchasePage && !hub && access.dataset.autoPopup === 'true';
  const attemptAuto = async () => {
    if (!autoEligible() || autoAttempting) return;
    if (Date.now() - browsingStarted < delay || overlayActive()) { autoTimer = setTimeout(attemptAuto, Math.max(5000, delay - (Date.now() - browsingStarted))); return; }
    autoAttempting = true;
    const session = await refresh();
    autoAttempting = false;
    if (session && autoEligible() && !overlayActive()) openChooser();
    else if (autoEligible()) autoTimer = setTimeout(attemptAuto, 30000);
  };
  if (autoEligible()) autoTimer = setTimeout(attemptAuto, Math.max(0, delay - (Date.now() - browsingStarted)));
  const refreshVisible = () => {
    if (!document.hidden && (otpSessionToken() || hub || signedIn) && Date.now() - sessionCheckedAt > 30000) void refresh();
  };
  document.addEventListener('visibilitychange', refreshVisible);
  window.addEventListener('pageshow', () => { syncScroll(); refreshVisible(); });
  let explicitMobileDestination = null;
  if (hub) {
    const entryUrl = new URL(location.href);
    if (entryUrl.searchParams.get('ff_login') === 'mobile') {
      explicitMobileDestination = localDestination(entryUrl.searchParams.get('return_to')) || hubUrl.pathname + hubUrl.search;
      entryUrl.searchParams.delete('ff_login');
      entryUrl.searchParams.delete('return_to');
      history.replaceState(history.state, '', entryUrl.pathname + entryUrl.search + entryUrl.hash);
    }
  }
  syncEntries();
  if (explicitMobileDestination) void requestLogin(explicitMobileDestination);
  else if (shopifySessionActive) { applySession({ active: true }, 'shopify'); navigateIntent(true); }
  else if (hub || otpSessionToken() || loginIntent) void refresh().then(session => { if (session?.active === true) navigateIntent(true); });
})();
